import en from '@/locales/en.json';
import hi from '@/locales/hi.json';
import ml from '@/locales/ml.json';
import kn from '@/locales/kn.json';
import ta from '@/locales/ta.json';
import te from '@/locales/te.json';

export type Language = 'en' | 'hi' | 'ml' | 'kn' | 'ta' | 'te';

export interface LanguageOption {
  code: Language;
  label: string;
  nativeLabel: string;
  flag: string;
}

export const SUPPORTED_LANGUAGES: LanguageOption[] = [
  { code: 'en', label: 'English', nativeLabel: 'English', flag: '🇬🇧' },
  { code: 'hi', label: 'Hindi', nativeLabel: 'हिंदी', flag: '🇮🇳' },
  { code: 'ml', label: 'Malayalam', nativeLabel: 'മലയാളം', flag: '🇮🇳' },
  { code: 'kn', label: 'Kannada', nativeLabel: 'ಕನ್ನಡ', flag: '🇮🇳' },
  { code: 'ta', label: 'Tamil', nativeLabel: 'தமிழ்', flag: '🇮🇳' },
  { code: 'te', label: 'Telugu', nativeLabel: 'తెలుగు', flag: '🇮🇳' },
];

const translations: Record<Language, typeof en> = { en, hi: hi as typeof en, ml: ml as typeof en, kn: kn as typeof en, ta: ta as typeof en, te: te as typeof en };

export function getTranslations(language: Language): typeof en {
  return translations[language] ?? translations.en;
}
